import React from "react";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";

const inputClass =
  "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500";

const inputErrorClass = "border border-red-500 b-2 text-red-500";
const labelClass =
  "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const MembershipProducts = ({ membershipType, disabledFields = [] }) => {
  const { register, errors, watch, unregister } = useFormContext();

  const watchedFields = watch([
    "meetingRoomSeats",
    "workStationSeats",
    "collabAreaSeats",
  ]);

  let totalSeatCount = Object.values(watchedFields).reduce((acc, value) => {
    acc += Object.is(value, NaN) ? 0 : Number(value);
    return acc;
  }, 0);

  if (membershipType === "2gethr Connect") {
    return (
      <WithConnectMembership
        register={register}
        errors={errors}
        unregister={unregister}
        totalSeatCount={totalSeatCount}
        disabledFields={disabledFields}
      />
    );
  }

  if (membershipType === "Private Office") {
    return (
      <WithAdditionalSeats
        register={register}
        errors={errors}
        unregister={unregister}
        totalSeatCount={totalSeatCount}
        disabledFields={disabledFields}
      />
    );
  }

  return (
    <WithoutAdditionalSeats
      register={register}
      errors={errors}
      unregister={unregister}
      totalSeatCount={totalSeatCount}
      disabledFields={disabledFields}
    />
  );
};

const WithConnectMembership = ({
  register,
  errors,
  unregister,
  membershipType,
  disabledFields,
}) => {
  return (
    <div className="md:flex">
      <div className="md:w-1/2 w-full mb-6">
        <label className={labelClass} htmlFor="totalDayPasses">
          Number of Day Passes
        </label>
        <input
          className={classNames({
            [inputClass]: true,
            [inputErrorClass]: errors?.totalDayPasses?.message,
          })}
          id="totalDayPasses"
          type="number"
          placeholder="Number Of Day Passes"
          name="totalDayPasses"
          ref={register}
        />
        {errors?.totalDayPasses?.message && (
          <div className="text-xs text-red-500 flex flex-row-reverse">
            <span>{errors?.totalDayPasses?.message}</span>
          </div>
        )}
      </div>
      <div className="md:w-1/2 w-full mb-6 md:ml-6">
        <label className={labelClass} htmlFor="price-month">
          Price / Pass
        </label>
        <input
          className={classNames({
            [inputClass]: true,
            [inputErrorClass]: errors?.rate?.message,
            "bg-disabledInput": disabledFields.indexOf("rate") > -1,
          })}
          id="price-month"
          type="number"
          placeholder="Price / Work Unit / Month"
          name="rate"
          ref={register}
          readOnly={disabledFields.indexOf("rate") > -1}
        />
        {errors?.rate?.message && (
          <div className="text-xs text-red-500 flex flex-row-reverse">
            <span>{errors?.rate?.message}</span>
          </div>
        )}
      </div>
    </div>
  );
};

const WithAdditionalSeats = ({
  register,
  errors,
  unregister,
  totalSeatCount,
  membershipType,
  disabledFields,
}) => {
  return (
    <>
      <div className="md:flex">
        <div className="md:w-1/2 w-full mb-6">
          <label className={labelClass} htmlFor="workStationSeats">
            Number of Work Stations
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors.workStationSeats && errors.workStationSeats.message,
            })}
            id="workStationSeats"
            type="number"
            placeholder="Number Of Work Stations"
            name="workStationSeats"
            ref={register}
          />
          {errors.workStationSeats && errors.workStationSeats && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.workStationSeats.message}</span>
            </div>
          )}
        </div>

        <div className="md:w-1/2 w-full mb-6 md:ml-6">
          <label className={labelClass} htmlFor="workStationSeats">
            Number of Meeting Room Seats
          </label>
          <input
            className={inputClass}
            type="number"
            name="meetingRoomSeats"
            ref={register}
            placeholder="No of Meeting Room Seats"
            id="meetingRoomSeats"
          />
        </div>
      </div>

      <div className="md:w-1/2 w-full mb-6">
        <label className={labelClass} htmlFor="collab-seats">
          Number of Collab Area Seats
        </label>
        <input
          className={inputClass}
          id="collab-seats"
          type="number"
          placeholder="Number of Collab Area Seats"
          name="collabAreaSeats"
          ref={register}
        />
      </div>
      <hr className="border b-2 mt-8" />
      {/* Show Total Work Units */}
      <div className="p-2">
        <h4>Total Work Units: {totalSeatCount}</h4>
      </div>
      <hr className="border b-2 mb-8" />

      <div className="md:flex">
        <div className="md:w-1/2 w-full mb-6">
          <label className={labelClass} htmlFor="rate">
            Price / Work Unit / Month
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]: errors.rate && errors.rate.message,
              "bg-disabledInput": disabledFields.indexOf("rate") > -1,
            })}
            id="price-month"
            type="number"
            placeholder="Price / Work Unit / Month"
            name="rate"
            ref={register}
            readOnly={disabledFields.indexOf("rate") > -1}
          />
          {errors.rate && errors.rate.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.rate.message}</span>
            </div>
          )}
        </div>
        <div className="md:w-1/2 w-full mb-6 md:ml-6">
          <label className={labelClass} htmlFor="credits">
            Meeting Room Credits
          </label>
          <input
            className={inputClass}
            id="credits"
            type="number"
            placeholder=" Meeting Room Credits"
            name="meetingRoomCredits"
            ref={register}
          />
        </div>
      </div>
    </>
  );
};

const WithoutAdditionalSeats = ({
  register,
  errors,
  unregister,
  membershipType,
  disabledFields,
}) => {
  return (
    <div className="md:flex">
      <div className="md:w-1/2 w-full mb-6">
        <label className={labelClass} htmlFor="workStationSeats">
          Number of Work Stations
        </label>
        <input
          className={classNames({
            [inputClass]: true,
            [inputErrorClass]:
              errors.workStationSeats && errors.workStationSeats.message,
          })}
          id="workStationSeats"
          type="number"
          placeholder="Number Of Work Stations"
          name="workStationSeats"
          ref={register}
        />
        {errors.workStationSeats && errors.workStationSeats.message && (
          <div className="text-xs text-red-500 flex flex-row-reverse">
            <span>{errors.workStationSeats.message}</span>
          </div>
        )}
      </div>
      <div className="md:w-1/2 w-full mb-6 md:ml-6">
        <label className={labelClass} htmlFor="price-month">
          Price / Work Unit / Month
        </label>
        <input
          className={classNames({
            [inputClass]: true,
            [inputErrorClass]: errors.rate && errors.rate.message,
            "bg-disabledInput": disabledFields.indexOf("rate") > -1,
          })}
          id="price-month"
          type="number"
          placeholder="Price / Work Unit / Month"
          name="rate"
          ref={register}
          readOnly={disabledFields.indexOf("rate") > -1}
        />
        {errors.rate && errors.rate.message && (
          <div className="text-xs text-red-500 flex flex-row-reverse">
            <span>{errors.rate.message}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MembershipProducts;
